<!-- TODO Should ConversationSearch and contactSearch both have the scope or should contactSearch really seach all like it is searching now? -->

<template>
  <div
    id="conversation-search"
    class="flex wrap center-all settings-css SB-border bottom"
    :class="{ 'add-shadow': searchActive || newConversationActive }"
    @click="focus" >
    <!-- Search view - CHECK IF THIS CAN BE REMOVED -->
    <template v-if="searchActive" >
      <div class="search-bar full-row flex center-all">
        <SBIcon
          :icon="SBIconList.MAGNIFIER"
          :color="SBColors.blackUltralight"
          :size="12" />
        <!-- Addition for placeholder once message search is done - 'and messages...' -->
        <b-form-input
          ref="searchBarInput"
          v-model="searchValue"
          class="greedy"
          autocomplete="off"
          type="search"
          placeholder="Search contacts"
          debounce="500"
          @update="emit" />
        <SBIcon
          id="cancel-search"
          :icon="SBIconList.CLOSE_THIN"
          :color="SBColors.blackUltralight"
          :hover-icon-color="SBColors.blackPrimary"
          :hover-color="SBColors.greyBorderSecondary"
          :size="8"
          :hover-size="18"
          :border-radius="50"
          :pointer="true"
          @click="closeSearchBar" />
        <b-popover
          target="cancel-search"
          :delay="250"
          triggers="hover"
          placement="bottom"
          custom-class="basic-popover" >
          Cancel
        </b-popover>
      </div>
      <div
        v-if="currentOrganisation.businesses.length > 1"
        class="search-filters full-row" >
        <div class="number-select flex center-all">
          <span
            v-if="isBusinessSelected"
            :class="{ active: targetNumber === 'Number' }"
            @click="setTargetNumber('Number')">Number</span>
          <span
            v-else
            :class="{ active: targetNumber === 'My' }"
            @click="setTargetNumber('My')">My chats</span>
          <span
            :class="{ active: targetNumber === 'All' }"
            @click="setTargetNumber('All')">All numbers</span>
        </div>
      </div>
    </template>

    <!-- New Conversation Search -->
    <template v-else-if="newConversationActive">
      <div class="search-bar full-row flex center-all">
        <span>To:</span>
        <div class="greedy">
          <div id="invalid-popover-target">
            <b-form-input
              v-show="!showInvalidView && !showValidView"
              ref="searchContactBarInput"
              v-model="searchContactValue"
              v-click-outside="() => !showInvalidView && !showValidView ? justValidateNumber() : null"
              type="search"
              autocomplete="off"
              placeholder=""
              @update="updateContactSearch" />
            <div
              v-show="showInvalidView"
              @click="editInvalidNumber()" >
              <div
                id="invalid-number"
                class="invalid-number"
                @mouseenter="showInvalidPopover = true"
                @mouseleave="showInvalidPopover = false" >
                {{ searchContactValue }}
                <SBIcon
                  :icon="SBIconList.CLOSE_THIN"
                  :color="SBColors.blackUltralight"
                  :hover-icon-color="SBColors.blackPrimary"
                  :hover-color="null"
                  :size="6"
                  :hover-size="22"
                  :pointer="true"
                  @click="clearInvalidNumber" />
              </div>
            </div>
            <div
              v-show="showValidView"
              @click="editInvalidNumber()" >
              <div
                class="valid-number" >
                {{ searchContactValue }}
                <SBIcon
                  :icon="SBIconList.CLOSE_THIN"
                  :color="SBColors.blackUltralight"
                  :hover-icon-color="SBColors.blackPrimary"
                  :hover-color="null"
                  :size="6"
                  :hover-size="22"
                  :pointer="true"
                  @click="clearInvalidNumber" />
              </div>
            </div>
          </div>
          <b-popover
            v-if="seachValueIsNumber"
            ref="newNumberPopoverRef"
            target="invalid-popover-target"
            :show.sync="showInvalidPopover"
            triggers="manual"
            placement="bottom"
            :no-fade="true"
            custom-class="no-pointer-events number-invalid-popover"
            @hide="invalidPopoverHide()" >
            <h1 class="error-color">Phone number format is wrong</h1>
            <p class="strong">Supported national format ({{ userRegion }})</p>
            <p>A phone number in {{ userRegion }} national format without country code and a plus sign (+).</p>
            <p><i>Example {{ examples.national }}</i></p>
            <p class="strong">Supported international format (E.164)</p>
            <p>A phone number in full international format that includes a plus sign (+).</p>
            <p><i>Example {{ examples.international }}</i></p>
          </b-popover>
        </div>
        <div id="cancel-new-message">
          <SBIcon
            :icon="SBIconList.CLOSE_THIN"
            :color="SBColors.blackUltralight"
            :hover-icon-color="SBColors.blackPrimary"
            :hover-color="SBColors.greyBorderSecondary"
            :size="8"
            :hover-size="18"
            :border-radius="50"
            :pointer="true"
            @click="closeNewConversationBar" />
        </div>
        <b-popover
          target="cancel-new-message"
          triggers="hover"
          placement="bottom"
          custom-class="basic-popover" >
          Cancel
        </b-popover>
      </div>
    </template>

    <!-- DEFAULT view - Folders view -->
    <div
      v-else
      class="folder-view-wrapper w-100 flex center-all">
      <span
        id="filter-open"
        class="folder-select"
        :class="{ active: activeFolder === Folders.OPEN && !manage && !searchValue }"
        @click="changeFolder(Folders.OPEN)" >
        Open
      </span>
      <b-popover
        v-if="!searchActive && !newConversationActive && !blockFilterPopover"
        ref="openPopoverRef"
        target="filter-open"
        triggers="hover"
        placement="bottom"
        custom-class="basic-popover" >
        Filter by open
      </b-popover>
      <span
        id="filter-done"
        class="folder-select"
        :class="{ active: activeFolder === Folders.DONE && !manage && !searchValue }"
        @click="changeFolder(Folders.DONE)" >
        Done
      </span>
      <b-popover
        v-if="!searchActive && !newConversationActive && !blockFilterPopover"
        ref="donePopoverRef"
        target="filter-done"
        triggers="hover"
        placement="bottom"
        custom-class="basic-popover" >
        Filter by done
      </b-popover>
      <!-- <span
        class="folder-select"
        :class="{ active: activeFolder === Folders.SPAM }"
        @click="changeFolder(Folders.SPAM)" >
        Spam
      </span> -->
      <div class="actions greedy flex justify-end">
        <!-- <b-button
          class="m-0 p-0 rounded"
          @click="toggleFilter" >
          <SBIcon
            v-if="!selectedFilters.length"
            :icon="SBIconList.FILTER"
            :color="SBColors.blackPrimary"
            :hover-size="30"
            :size="12"
            :counter="selectedFilters.length" />
          <div
            v-else
            class="counter" >{{ selectedFilters.length }}</div>
        </b-button> -->
        <!-- <b-button
          id="search-conversations"
          class="m-0 p-0 rounded">
          <SBIcon
            :icon="SBIconList.MAGNIFIER"
            :color="SBColors.blackPrimary"
            :hover-size="30"
            :size="14"
            @click="showSearchBar" />
        </b-button> -->
        <!-- <b-popover
          target="search-conversations"
          triggers="hover"
          placement="bottom"
          custom-class="basic-popover" >
          Search conversations
        </b-popover> -->

        <router-link
          v-if="isNumberView"
          :to="{ name: 'NumberManage' }"
          exact-path >
          <span
            id="manage-btn"
            class="folder-select flex center-all"
            :class="{ active: manage }"
            @click="() => {}" >
            <span class="icon-wrapper" />
            <p>Manage</p>
          </span>
        </router-link>
        <!-- <span
          id="manage-btn"
          class="folder-select flex center-all"
          :class="{ active: activeFolder === 'MANAGE' }"
          @click="() => {}" >
          <span class="icon-wrapper" />
          <p>Manage</p>
        </span> -->
      </div>
    </div>

    <b-popover
      target="manage-btn"
      triggers="hover"
      placement="bottom"
      custom-class="basic-popover" >
      Manage phone number
    </b-popover>

    <!-- SEARCH and FILTER section -->
    <div
      v-if="!basic && !newConversationActive"
      class="search-bar full-row flex center-all SB-border top">
      <div class="search-wrapper greedy flex center-all">
        <SBIcon
          style="margin-left: 12px;"
          :icon="SBIconList.MAGNIFIER"
          :color="SBColors.blackUltralight"
          :size="12" />
        <!-- Addition for placeholder once message search is done - 'and messages...' -->
        <b-form-input
          ref="searchBarInput"
          v-model="searchValue"
          class="greedy"
          autocomplete="off"
          type="search"
          :placeholder="`Search${currentBusiness ? ' ' : ''}${currentBusiness ? currentBusiness.name : ''}...`"
          debounce="500"
          @update="emit" />
        <SBIcon
          v-if="searchValue"
          id="cancel-search"
          style="margin-right: 7px;"
          :icon="SBIconList.CLOSE_THIN"
          :color="SBColors.blackUltralight"
          :hover-icon-color="SBColors.blackPrimary"
          :size="8"
          :hover-size="18"
          :border-radius="50"
          :pointer="true"
          @click="closeSearchBar" />
        <b-popover
          target="cancel-search"
          :delay="250"
          triggers="hover"
          placement="bottom"
          custom-class="basic-popover" >
          Clear
        </b-popover>
      </div>

      <div
        id="filter-conversations"
        @click="toggleFilter" >
        <SBIcon
          v-if="!selectedFilters.length"
          class="filter"
          style="margin-left: 0px;"
          :icon="SBIconList.FILTER_LINES"
          :color="SBColors.blackUltralight"
          :hover-icon-color="SBColors.blackPrimary"
          :pointer="true"
          :size="14"
          :hover-size="24"
          :active="blockFilterPopover" />
        <div
          v-else
          class="counter flex center-all"
          :class="{ active: blockFilterPopover }" >{{ selectedFilters.length }}</div>
      </div>

      <b-popover
        v-if="!searchActive && !newConversationActive && !blockFilterPopover"
        target="filter-conversations"
        triggers="hover"
        placement="bottom"
        custom-class="basic-popover" >
        Filter conversations
      </b-popover>
      <b-popover
        ref="filterPopoverRef"
        target="filter-conversations"
        triggers="manual"
        placement="bottom"
        custom-class="interactive-popover popover-offset-sb sb2-dropdown hide-arrow mt-1"
        @hidden="resetFilterPopover()" >
        <div class="animation-wrapper">
          <div
            v-click-outside="closeFilter"
            class="animation-view"
            :class="{ 'go-out': showMemberSelectView || showTagSelectView }" >
            <div
              class="main-view"
              :class="{ 'min-height': !showMain }" >
              <header class="flex center-all">
                <b-button
                  class="flex center-all"
                  @click="clearFilter">
                  <span>Clear</span>
                </b-button>
                <span class="title greedy flex center-all">Filters</span>
                <b-button
                  variant="primary"
                  class="flex center-all"
                  @click="saveFilter">
                  <span>Save</span>
                </b-button>
              </header>
              <h5 class="group-title">Folders</h5>
              <searchable-list
                title="Filters"
                :class="{ 'add-bottom-margin': myChatsView }"
                :item-list="filterOptions"
                :clear-all-displayed="false"
                :hide-title="true"
                @item-selected="selectFilter" >
                <template #default="slotProps">
                  <div
                    class="sb2-dropdown-item flex center-all"
                    :class="{checked: selectedFilters.findIndex(filter => filter.value === slotProps.item.text) >= 0}">
                    <SBIcon
                      class="m-0"
                      :icon="slotProps.item.icon"
                      :color="SBColors.blackPrimary"
                      :size="16" />
                    <span
                      class="title-wrap ellipsis"
                      :inner-html.prop="slotProps.item.text | boldMatch(slotProps.searchTerm)" />
                    <SBIcon
                      v-if="selectedFilters.findIndex(filter => filter === slotProps.item.value) >= 0"
                      :icon="SBIconList.DONE_TICK"
                      :color="SBColors.bluePrimary"
                      :size="9" />
                  </div>
                </template>
              </searchable-list>
              <div
                v-if="!myChatsView"
                class="member-filter" >
                <h5 class="group-title">Team members</h5>
                <div
                  class="member-filter-item flex center-all"
                  @click="memberSelectToggle()" >
                  <!-- <SBIcon
                    v-if="!filterSelectedMember"
                    :icon="SBIconList.QUESTIONMARK"
                    :color="SBColors.white"
                    :background-color="SBColors.greyPrimary"
                    :hover-size="16"
                    :border-radius="50"
                    :size="8" /> -->
                  <!-- <SBIcon
                    v-if="!filterSelectedMember"
                    :icon="SBIconList.PROFILE_CIRCLE"
                    :color="SBColors.blackPrimary"
                    :hover-size="16"
                    :border-radius="50"
                    :size="16" /> -->
                  <SBAvatarImage
                    class="item-icon"
                    :class="{'not-selected' : !(filterSelectedMember && filterSelectedMember.id)}"
                    :name="filterSelectedMember && filterSelectedMember.id ? filterSelectedMember.name : '?'"
                    :image="filterSelectedMember ? filterSelectedMember.avatar : null"
                    :available="filterSelectedMember && filterSelectedMember.available && filterSelectedMember.online"
                    :show-availability-status="false"
                    :size="SBAvatarImageSize.W16" />
                  <p
                    class="member-name greedy m-0"
                    :class="{ empty: !filterSelectedMember || emptyObject(filterSelectedMember) }" >{{ filterSelectedMember && !emptyObject(filterSelectedMember) ? filterSelectedMember.name : 'Select team member...' }}</p>
                  <SBIcon
                    v-if="true"
                    class="rotate-270"
                    :icon="SBIconList.DOWN_ARROW"
                    :color="!filterSelectedMember || emptyObject(filterSelectedMember) ? SBColors.greyPrimary : SBColors.blackUltralight"
                    :size="11" />
                </div>
              </div>
              <!-- Contact tags filter is supported only on the number conversations -->
              <div
                v-if="isNumberView"
                class="member-filter" >
                <h5 class="group-title">Contact tags</h5>
                <div
                  class="member-filter-item flex center-all"
                  @click="tagSelectToggle()" >
                  <SBIcon
                    :icon="SBIconList.TAG"
                    :color="filterSelectedTags.length ? SBColors.blackPrimary : SBColors.greyPrimary"
                    :size="12"
                    :hover-size="16" />
                  <p
                    class="member-name tag-names greedy m-0"
                    :class="{ empty: !filterSelectedTags.length }" >{{ filterSelectedTags.length ? filterSelectedTagNames : 'Select contact tags...' }}</p>
                  <SBIcon
                    class="rotate-270"
                    :icon="SBIconList.DOWN_ARROW"
                    :color="!filterSelectedTags.length ? SBColors.greyPrimary : SBColors.blackUltralight"
                    :size="11" />
                </div>
              </div>
            </div>
            <div
              class="member-select-view"
              :class="{'go-in': showMemberSelectView || showTagSelectView, 'min-height': !showMemberSelect && !showTagSelect}">
              <SBIcon
                v-if="true"
                class="back-arrow rotate-90"
                :icon="SBIconList.DOWN_ARROW"
                :color="SBColors.blackUltralight"
                :size="11"
                @click="goBack" />
              <!-- Removed while tags are selected so its window key listener doesn't select team members -->
              <AssignConversationAssignMenu
                v-if="!showTagSelect"
                ref="memberSelectComponentRef"
                :prevent-initial-focus="true"
                :select-by-provided="true"
                :select-user="filterSelectedMember"
                :show-availability-status="false"
                :hide-unassigned="true"
                :can-be-cleared="true"
                @item-selected="selectMemberFilter" />
              <ContactTagSelectMenu
                v-if="isNumberView"
                v-show="showTagSelect"
                ref="tagSelectComponentRef"
                :selected-tags="filterSelectedTags"
                @change="selectTagFilter" />

            </div>
          </div>
        </div>
      </b-popover>
    </div>

    <!-- POPOVERS -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ClickOutside from 'v-click-outside';
import examples from 'libphonenumber-js/examples.mobile';
import { AsYouType, parsePhoneNumber, getExampleNumber } from 'libphonenumber-js/max';
import { position } from 'caret-pos';
import { debounce } from 'debounce';

import Folders from '@/helpers/lists/folders';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SBColors from '@/helpers/lists/colors';
import SearchableList from '@/components/common/SearchableList';
import AssignConversationAssignMenu from '@/components/organisation/assign_conversation/AssignMenu';
import SBAvatarImage from '@/components/common/AvatarImage';
import SBAvatarImageSize from '@/helpers/lists/avatarSize';
import ContactTagSelectMenu from '@/components/business/chat/partials/ContactTagSelectMenu';

export default {
  name: 'ConversationHeader',
  components: {
    SBIcon,
    SearchableList,
    AssignConversationAssignMenu,
    SBAvatarImage,
    ContactTagSelectMenu,
  },
  directives: {
    ClickOutside: ClickOutside.directive,
  },
  props: {
    value: {
      type: Object,
      required: false,
      default: () => {},
    },
    basic: {
      type: Boolean,
      reuired: false,
      default: false,
    },
    manage: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      searchValue: '',
      searchContactValue: '',
      activeFolder: Folders.OPEN,
      filterBranchPopoverVisible: false,
      searchActive: false,
      newConversationActive: false,
      targetNumber: 'Number',
      newConversationTargetBranch: null,
      blockFilterPopover: false,
      selectedFilters: [],
      showMemberSelectView: false,
      userId: localStorage.getItem('userId'),
      showMemberSelect: false,
      showTagSelectView: false,
      showTagSelect: false,
      showMain: true,
      filterSelectedMember: null,
      filterSelectedTags: [],
      caretPosition: 0,
      preventSearchContactValueChange: false,
      showValidView: false,
      showInvalidView: false,
      showInvalidPopover: false,
      savedSelection: {
        selectedFilters: [],
        filterSelectedMember: null,
        filterSelectedTags: [],
      },
      examples: {
        national: '',
        international: '',
      },
      Folders,
      SBIconList,
      SBColors,
      SBAvatarImageSize,
    };
  },
  computed: {
    ...mapGetters({
      activeInbox: 'inbox/activeInbox',
      currentOrganisation: 'organisation/currentOrganisation',
      merchantId: 'merchant/merchantId', // TODO test this once the merchant for organizations are being loaded
      startNewConversationSelectId: 'chat/startNewConversationSelectId',
      organisationContactList: 'contact/organisationContactList',
      userRegion: 'user/region',
      allowEnter: 'chat/allowEnter',
      vuexFolder: 'chat/folder',
      resetConversationListFlag: 'chat/resetConversationListFlag',
    }),
    currentBusiness() {
      if (this.isBusinessSelected && this.$route.name !== 'OrganisationConversation') {
        return this.currentOrganisation.businesses.find(b => b.id === this.$route.params.businessId);
      }
      return null;
    },
    isBusinessSelected() {
      return !!this.$route.params.businessId;
    },
    filterOptions() {
      let options = [
        {
          icon: SBIconList.CONVERSATION_UNREAD,
          text: 'Unread',
          value: 'unread',
        },
      ];
      if (this.$route.params.businessId) {
        options = [...options,
          {
            icon: SBIconList.QUESTION_CIRCLE,
            text: 'Unassigned',
            value: 'unassigned',
          },
          {
            icon: SBIconList.ARROW_CIRCLE,
            text: 'Assigned',
            value: 'assigned',
          },
        ];
      }
      return options;
    },
    isNumberView() {
      return this.isBusinessSelected && this.$route.name !== 'OrganisationConversation';
    },
    filterSelectedTagNames() {
      return this.filterSelectedTags.map(tag => tag.name).join(', ');
    },
    myChatsView() {
      return !this.$route.params.businessId && this.userId;
    },
    seachValueIsNumber() {
      const regex = /^[+\-()0-9\s]+$/;
      return regex.test(this.searchContactValue);
    },
    searchIsNumber() {
      const regex = /^[+\-()0-9\s]+$/;
      return regex.test(this.searchValue);
    },
  },
  watch: {
    $route(to) {
      this.setTargetNumberFromRoute(to);
      this.showInvalidView = false;
      this.showValidView = false;
    },
    resetConversationListFlag() {
      if (this.resetConversationListFlag) {
        this.closeNewConversationBar();
        this.resetConversationList(false);
      }
    },
    activeInbox() {
      this.closeSearchBar();
      this.closeNewConversationBar();
      this.setSearchAllNumbersButton(false);
      this.setTargetNumberFromRoute(this.$route);
    },
    vuexFolder() {
      this.changeFolder(this.vuexFolder);
    },
    newConversationActive() {
      this.$nextTick(() => {
        if (this.newConversationActive) {
          this.closeSearchBar();
          this.setInputLiteners();
        }
      });
    },
    searchValue() {
      const startsWith00 = /^00/.test(this.searchValue);
      const tempValue = this.searchValue.replace(/^00/, '+');
      if (this.preventSearchContactValueChange) {
        this.preventSearchContactValueChange = false;
        return;
      }
      this.caretPosition = position(this.$refs.searchBarInput.$el).pos;
      const currentInput = this.searchValue.toString();
      const uptoCarretNoSpace =
        currentInput
          .substring(0, this.caretPosition)
          .replaceAll(' ', '')
          .split('')
          .join('\\s*')
          .replaceAll('\\\\', '\\')
          .replaceAll('+', '\\+');

      if (!this.searchIsNumber) {
        return;
      }

      const asYouTypeInstance = new AsYouType(this.userRegion);
      asYouTypeInstance.input(tempValue);
      const outputValue = startsWith00 ? `00 ${asYouTypeInstance.formattedOutput.replace(/^\+/, '')}` : asYouTypeInstance.formattedOutput;
      this.searchValue = outputValue;
      this.preventSearchContactValueChange = true;
      setTimeout(() => {
        this.preventSearchContactValueChange = false;
      });

      this.$nextTick(() => {
        const matchCarretPos = this.searchValue.match(uptoCarretNoSpace);
        if (matchCarretPos) {
          this.$refs.searchBarInput.$el.setSelectionRange(matchCarretPos[0].length, matchCarretPos[0].length);
        }
      });
    },
    searchContactValue() {
      const startsWith00 = /^00/.test(this.searchContactValue);
      const tempValue = this.searchContactValue.replace(/^00/, '+');
      // console.log(startsWith00, tempValue);
      if (this.preventSearchContactValueChange) {
        this.preventSearchContactValueChange = false;
        return;
      }
      this.caretPosition = position(this.$refs.searchContactBarInput.$el).pos;
      const currentInput = this.searchContactValue.toString();
      const uptoCarretNoSpace =
        currentInput
          .substring(0, this.caretPosition)
          .replaceAll(' ', '')
          .split('')
          .join('\\s*')
          .replaceAll('\\\\', '\\')
          .replaceAll('+', '\\+');

      if (!this.seachValueIsNumber) {
        return;
      }

      // Phone parsing is important here so we do not process names or anx non valid phone number
      // let parsedPhone;
      // try {
      //   parsedPhone = parsePhoneNumber(tempValue, this.userRegion);
      // } catch (error) {
      //   // console.log(error);
      //   return;
      // }
      // console.log('PARSED', parsedPhone);
      // if (!parsedPhone.isValid()) {
      //   console.log('INVALID');
      //   return;
      // }

      const asYouTypeInstance = new AsYouType(this.userRegion);
      asYouTypeInstance.input(tempValue);
      const outputValue = startsWith00 ? `00 ${asYouTypeInstance.formattedOutput.replace(/^\+/, '')}` : asYouTypeInstance.formattedOutput;
      this.searchContactValue = outputValue;
      this.preventSearchContactValueChange = true;
      setTimeout(() => {
        this.preventSearchContactValueChange = false;
      });

      this.$nextTick(() => {
        const matchCarretPos = this.searchContactValue.match(uptoCarretNoSpace);
        if (matchCarretPos) {
          this.$refs.searchContactBarInput.$el.setSelectionRange(matchCarretPos[0].length, matchCarretPos[0].length);
        }
      });
    },
  },
  mounted() {
    this.$eventBus.$on('close-new-conversation-bar', this.closeNewConversationBar);
    this.$eventBus.$on('show-contact-search-view', this.showContactSearchView);
    this.$eventBus.$on('simulate-enter-pressed', this.validatePhoneNumber);
    this.setTargetNumberFromRoute(this.$route);
    window.addEventListener('keydown', this.handleKeyDown);
    if (!this.manage) {
      this.changeFolder(this.vuexFolder);
    }
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyDown);
  },
  methods: {
    ...mapActions({
      setActiveInbox: 'inbox/setActiveInbox',
      setSearchAllNumbersButton: 'chat/setSearchAllNumbersButton',
      setCurrentFolder: 'inbox/setCurrentFolder',
      setStartNewConversationSelectId: 'chat/setStartNewConversationSelectId',
      setStartNewConversation: 'chat/setStartNewConversation',
      setAllowEnter: 'chat/setAllowEnter',
      enterPressed: 'chat/enterPressed',
      setFolder: 'chat/setFolder',
      resetConversationList: 'chat/resetConversationList',
      populateConversationCache: 'chat/populateConversationCache',
    }),
    changeFolder(targetFolder) {
      if (this.manage) {
        this.$router.push({ name: 'OrganisationBusiness' });
      }

      this.activeFolder = targetFolder;

      if (this.$refs.openPopoverRef) this.$refs.openPopoverRef.$emit('close');
      if (this.$refs.donePopoverRef) this.$refs.donePopoverRef.$emit('close');

      const folderData = {
        filters: {
          folder: this.activeFolder,
        },
      };

      this.setActiveInbox(folderData);
      this.setCurrentFolder(this.activeFolder);
      this.setFolder(this.activeFolder);
    },
    clearFilter() {
      const shouldDataBeReloaded = this.savedSelection.selectedFilters.length || this.savedSelection.filterSelectedMember !== null || this.savedSelection.filterSelectedTags.length;
      this.selectedFilters = [];
      this.filterSelectedMember = null;
      this.filterSelectedTags = [];
      this.savedSelection.selectedFilters = [];
      this.savedSelection.filterSelectedMember = null;
      this.savedSelection.filterSelectedTags = [];
      if (shouldDataBeReloaded) {
        this.emitFilter();
      }
      this.closeFilter();
    },
    closeSearchBar() {
      this.searchActive = false;
      this.searchValue = '';
      this.setTargetNumberFromRoute(this.$route);
      this.emit();
    },
    closeFilter() {
      if (this.$refs.filterPopoverRef) {
        this.$refs.filterPopoverRef.$emit('close');
      }
      this.blockFilterPopover = false;

      this.selectedFilters = [...this.savedSelection.selectedFilters];
      this.filterSelectedMember = this.savedSelection.filterSelectedMember ? { ...this.savedSelection.filterSelectedMember } : null;
      this.filterSelectedTags = [...this.savedSelection.filterSelectedTags];
    },
    closeNewConversationBar() {
      this.newConversationActive = false;
      this.searchContactValue = '';
      this.emit();
      this.$eventBus.$emit('enable-new-message');
    },
    focus() {
      if (this.searchActive) {
        this.$refs.searchBarInput.focus();
      }
    },
    focusNewConversationSearch() {
      if (this.newConversationActive && this.$refs.searchContactBarInput) {
        this.$nextTick(() => {
          this.$refs.searchContactBarInput.focus();
        });
      }
    },
    emit() {
      let emitValue = this.searchValue.trim();
      // If number then emitValue should be trimmed and all the spaces should be removed but if string then trimm only.
      if (this.searchIsNumber) {
        emitValue = this.searchValue.replaceAll(' ', '').replace(/^0/, ''); // ignore leading 0 in case someone starts search with 09x because we store numbers as +3859xxxxxxxx,
      }
      this.$emit('input', {
        type: 'conversationSearch',
        conversationSearch: emitValue,
        scope: this.targetNumber,
      });
      this.setStartNewConversationSelectId(null);
    },
    updateContactSearch() {
      this.setAllowEnter(false);
      this.emitContactSearch();
    },
    emitContactSearch: debounce(function f() {
      if (!this.newConversationActive) {
        return;
      }
      this.$emit('input', {
        type: 'contactSearch',
        contactSearch: this.seachValueIsNumber ? this.searchContactValue.replaceAll(' ', '').replace(/^0/, '') : this.searchContactValue, // ignore leading 0 in case someone starts search with 09x because we store numbers as +3859xxxxxxxx
        branchId: this.newConversationTargetBranch.id,
      });
      this.setStartNewConversationSelectId(null);
    }, '500'),
    selectFilter(option) {
      const optionIndex = this.selectedFilters.findIndex(selectedOption => option.value === selectedOption);
      if (optionIndex > -1) {
        this.selectedFilters.splice(optionIndex, 1);
      } else {
        this.selectedFilters.push(option.value);
      }
    },
    emitFilter() {
      this.$emit('filter', {
        filters: this.selectedFilters,
        member: this.filterSelectedMember,
        tags: this.filterSelectedTags,
      });
    },
    setTargetNumber(targetNumber, triggerEmit = true) {
      this.targetNumber = targetNumber;
      if (triggerEmit) {
        this.emit();
      }
      if (targetNumber === 'All') {
        this.setSearchAllNumbersButton(true);
      } else {
        this.setSearchAllNumbersButton(false);
      }
    },
    setTargetNumberFromRoute(route) {
      if (route.params.businessId) {
        this.setTargetNumber('Number', false);
      } else {
        this.setTargetNumber('My', false);
      }
    },
    showSearchBar() {
      this.searchActive = true;
      this.$nextTick(() => {
        this.focus();
      });
    },

    showContactSearchView(branch) {
      this.$eventBus.$emit('disable-new-message');
      this.newConversationTargetBranch = branch;
      this.newConversationActive = true;
      this.emitContactSearch();
      this.populateConversationCache(branch.id);

      this.$nextTick(() => {
        this.focusNewConversationSearch();
      });
    },
    toggleFilter() {
      if (this.$refs.filterPopoverRef && !this.$refs.filterPopoverRef.localShow) {
        this.$refs.filterPopoverRef.$emit('open');
        this.blockFilterPopover = true;
      } else {
        this.closeFilter();
      }
    },
    resetFilterPopover() {
      this.showMemberSelectView = false;
      this.showMemberSelect = false;
      this.showTagSelectView = false;
      this.showTagSelect = false;
      this.showMain = true;
    },
    memberSelectToggle() {
      this.showMemberSelectView = !this.showMemberSelectView;
      if (this.showMemberSelectView) {
        this.showMemberSelect = true;
        setTimeout(() => {
          this.showMain = false;
        }, 80);
        setTimeout(() => {
          this.$refs.memberSelectComponentRef.focusSearchTermInput();
        }, 700);
      } else {
        this.showMain = true;
        setTimeout(() => {
          this.showMemberSelect = false;
        }, 80);
      }
    },
    selectMemberFilter(memberData) {
      this.filterSelectedMember = memberData;
      const perMemberFilter = this.selectedFilters.findIndex(filter => filter === 'per member');
      if (memberData && !(perMemberFilter >= 0)) {
        this.selectedFilters.push('per member');
      } else if (!memberData && (perMemberFilter >= 0)) {
        this.selectedFilters.splice(perMemberFilter, 1);
      }

      this.memberSelectToggle();
    },
    tagSelectToggle() {
      this.showTagSelectView = !this.showTagSelectView;
      if (this.showTagSelectView) {
        this.showTagSelect = true;
        setTimeout(() => {
          this.showMain = false;
        }, 80);
        setTimeout(() => {
          // Focusing the input while the view is not shown would move the hidden area into the view
          if (this.showTagSelectView && this.$refs.tagSelectComponentRef) {
            this.$refs.tagSelectComponentRef.focusSearchTermInput();
          }
        }, 700);
      } else {
        this.showMain = true;
        setTimeout(() => {
          this.showTagSelect = false;
        }, 80);
      }
    },
    /** Tags can be multiselected so the tag select view stays opened until user goes back. */
    selectTagFilter(tags) {
      this.filterSelectedTags = tags;
      const perTagFilter = this.selectedFilters.findIndex(filter => filter === 'per tag');
      if (tags.length && !(perTagFilter >= 0)) {
        this.selectedFilters.push('per tag');
      } else if (!tags.length && (perTagFilter >= 0)) {
        this.selectedFilters.splice(perTagFilter, 1);
      }
    },
    goBack() {
      if (this.showTagSelectView) {
        this.tagSelectToggle();
      } else {
        this.memberSelectToggle();
      }
    },
    saveFilter() {
      this.savedSelection = {
        selectedFilters: [...this.selectedFilters],
        filterSelectedMember: this.filterSelectedMember ? { ...this.filterSelectedMember } : null,
        filterSelectedTags: [...this.filterSelectedTags],
      };
      this.emitFilter();
      this.closeFilter();
    },
    select(itemId) {
      this.setStartNewConversationSelectId(itemId);
      // this.scrollIntoViewIfNeeded(this.$refs.itemListWrapperRef.children[itemId]);
    },
    handleKeyDown(event) {
      switch (event.keyCode) {
        case 38: // UP
          // this.preventMouseAction();
          if (this.startNewConversationSelectId > 0) {
            this.select(this.startNewConversationSelectId - 1);
          } else if (this.startNewConversationSelectId === 0) {
            this.select(null);
          }
          event.preventDefault();
          break;
        case 40: // DOWN
          // this.preventMouseAction();
          if (this.startNewConversationSelectId === null) {
            this.select(0);
          } else if (this.startNewConversationSelectId < this.organisationContactList.data.length) {
            this.select(this.startNewConversationSelectId + 1);
          }
          event.preventDefault();
          break;
        case 13: // ENTER
          if (!this.allowEnter) {
            console.log('ena');
            return;
          }
          if (this.startNewConversationSelectId !== null) {
            this.enterPressed();
          } else {
            console.log('v');
            this.validatePhoneNumber();
          }
          break;
        default:
          break;
      }
    },
    validatePhoneNumber() {
      if (!this.searchContactValue || !this.seachValueIsNumber) {
        return;
      }

      const plusVersionOfNumber = this.searchContactValue.replace(/^00/, '+');
      let parsedPhone;

      try {
        parsedPhone = parsePhoneNumber(plusVersionOfNumber, this.userRegion);
        this.phoneValid = !!(
          parsedPhone &&
          parsedPhone.isValid()
        );
      } catch (error) {
        this.phoneValid = false;
        this.showInvalidView = true;
      }

      if (this.phoneValid) {
        this.setStartNewConversation(parsedPhone.number);
      } else if (this.phoneValid) {
        this.showValidView = true;
      } else {
        const phoneNumberExamples = getExampleNumber(this.userRegion, examples);
        this.examples = {
          national: phoneNumberExamples.formatNational(),
          international: phoneNumberExamples.formatInternational(),
        };
        this.showInvalidView = true;
      }
    },
    justValidateNumber() {
      if (!this.searchContactValue || !this.seachValueIsNumber) {
        return;
      }

      const plusVersionOfNumber = this.searchContactValue.replace(/^00/, '+');
      let parsedPhone;

      try {
        parsedPhone = parsePhoneNumber(plusVersionOfNumber, this.userRegion);
        this.phoneValid = !!(
          parsedPhone &&
          parsedPhone.isValid()
        );
      } catch (error) {
        this.phoneValid = false;
      }

      if (this.phoneValid) {
        this.showValidView = true;
      } else {
        const phoneNumberExamples = getExampleNumber(this.userRegion, examples);
        this.examples = {
          national: phoneNumberExamples.formatNational(),
          international: phoneNumberExamples.formatInternational(),
        };
        this.showInvalidView = true;
      }
    },
    editInvalidNumber() {
      setTimeout(() => {
        // MUST be set on timeout so the v-click outside fires before the flags are set. Othervise the click outside directive would reset it all.
        this.invalidPopoverHide();
        this.showValidView = false;
        this.showInvalidView = false;
        this.focusNewConversationSearch();
      }, 0);
    },
    clearInvalidNumber() {
      this.showValidView = false;
      this.showInvalidView = false;
      this.searchContactValue = '';
      this.setStartNewConversationSelectId(null);
      this.emitContactSearch();
      this.focusNewConversationSearch();
    },
    invalidPopoverHide() {
      this.showInvalidPopover = false;
    },
    setInputLiteners() {
      if (this.newConversationActive && this.$refs.searchContactBarInput) {
        // We decided to listen on it on the window and not on the input only
        // this.$refs.searchContactBarInput.$el.addEventListener('keydown', this.handleKeyDown);
      } else {
        // console.log('NO INPUT FOR A LISTENER'); // DEBUG - TODO remove when solved
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin active-state {
  border-radius: 15px;
  box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.15);
  border: solid 1px #cfd8dc;
}

#filter-conversations {
  min-width: 24px !important;
  cursor: pointer;

  .counter {
    font-size: 14px !important;
    font-weight: 500 !important;
    color: #2680eb !important;
  }
}

#filter-conversations:focus {
  box-shadow: 0 1px 3px 0 rgb(48 54 70 / 15%) !important;
}

#conversation-search {
  background: white;
  // box-shadow: 0 1px $greyBorderSecondary;
  z-index: 1000;
  min-height: 54px;
  // padding: 0 12px;

  &.add-shadow {
    box-shadow: 0 3px 6px 0 rgba(48, 54, 70, 0.15);
  }

  .folder-view-wrapper {
    min-height: 54px;
    padding: 0 10px 0 12px;
  }

  .search-filters {
    .number-select {
      margin-bottom: 12px;

      span {
        background: $greyBorderSecondary;
        width: 50%;
        text-align: center;
        font-size: 13px;
        font-weight: 500;
        line-height: 1.32;
        color: $blackLight;
        padding: 4px;
        cursor: pointer;

        &.active {
          background: $blackLight;
          color: $greyUltralight;
        }

        &:first-child {
          border-radius: 7px 0 0 7px;
        }

        &:last-child {
          border-radius: 0 7px 7px 0;
        }
      }
    }
  }

  span.folder-select {
    margin-right: 9px;
    padding: 4px 10px 5px;
    background-color: $white;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.2;
    color: $blackUltralight;
    border-radius: 15px;
    border: solid 1px $white;
    cursor: pointer;

    &.active {
      color: $blackPrimary;
      @include active-state;

      &:hover {
        box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.30);
      }
    }

    &:not(.active):hover {
      background-color: $greyChatBubble;
    }
  }

  .actions .btn {
    margin-left: 10px !important;
  }

  .actions {
    #manage-btn {
      padding: 5px 11px 5px 13px;
      cursor: pointer;
      margin-right: 0 !important;

      .icon-wrapper {
        display: block;
        background-image: url('~@/assets/img/SB-Icons/manage.svg');
        width: 14px;
        height: 14px;
        background-repeat: no-repeat;
        background-size: 14px;
        background-position: center left;
        padding-left: 20px;
      }

      p {
        font-size: 14px;
        font-weight: 500;
        background: linear-gradient(92deg, #b937c7 0%, #351888 33%, #1383a2 65%, #099d60 100%);
        background-clip: text;
        -webkit-text-fill-color: transparent;
        line-height: initial !important;
      }

      &:hover, &.active {
        border-radius: 25px;
        background-image: linear-gradient(105deg, #fffff0, #fff2fc 29%, #efffff 67%, #f0fff0 100%);
      }
    }
  }

  .search-bar {
    width: 100%;
    padding: 0 7px 0 12px;
    height: 50px;

    .search-wrapper {
      border-radius: 6px;
      height: 30px;
      background-color: $greyChatBubble;
      margin-right: 6px;
    }

    .filter {
      padding: 0 5px;
    }

    .counter {
      font-size: 12px !important;
      font-weight: 500 !important;
      color: #2680eb !important;

      width: 24px;
      height: 24px;
      margin: 0;
      padding: 5px 8px 4px;
      box-shadow: 0 0 3px 0 rgba(48, 54, 70, 0.15);
      border: solid 1px $greyBorder;
      background-color: $white;
      border-radius: 50px;

      &:hover, &.active {
        box-shadow: 0 0 3px 0 rgba(48, 54, 70, 0.3);
      }
    }

    .sb-icon {
      top: 1px;
    }

    span {
      font-size: 14px;
      line-height: 1.23;
      color: #7c8b91;
    }

    span + input {
      padding-left: 3px;
      font-size: 14px;
      line-height: 1.23;
      color: $blackPrimary;
    }

    #invalid-popover-target {
      display: inline-block;
      width: 100%;

      .invalid-number {
        position: relative;
        margin-left: 5px;
        padding: 4px 22px 3px 8px;
        border-radius: 5px;
        background-color: #fcefef;
        cursor: pointer;
        display: inline-block;
        font-size: 14px;

        .sb-icon {
          position: absolute;
          top: 0px;
          right: 0px;
        }
      }

      .valid-number {
        position: relative;
        margin-left: 5px;
        padding: 4px 22px 3px 8px;
        border-radius: 5px;
        background-color: #E7F0FD;
        cursor: pointer;
        display: inline-block;
        font-size: 14px;

        .sb-icon {
          position: absolute;
          top: 0px;
          right: 0px;
        }
      }
    }
  }
}

.popover-offset-sb {
  margin-left: 0px;
}

.rotate-270 {
  transform: rotate(270deg);
}

.rotate-90 {
  transform: rotate(90deg);
}

.member-filter {
  border-top: solid 1px #e0e7e9;
  padding: 0 0 7px 0;
  margin-top: 7px;

  .member-filter-item {
    padding: 11px 16px;
    cursor: pointer;

    &:hover {
      background-color: $hover;
    }

    .not-selected {
      background-color: $greyPrimary !important;
    }

    // Nested in the item so the padding overrides the global popover paragraph style (.popover-body p:not(:first-child))
    .member-name {
      padding-left: 13px;
      font-size: 14px;
      color: $blackPrimary;

      &.empty {
        color: $greyPrimary !important;
      }

      &.tag-names {
        min-width: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}

.animation-wrapper {
  width: 297px;
  overflow: hidden;

  .animation-view {
    width: 200%;
    display: flex;
    transition: transform 0.1s ease-in;
    &.go-out {
      transform: translateX(-50%);
    }

    .main-view {
      width: 100%;
      max-width: 297px;

      .add-bottom-margin {
        margin-bottom: 7px;
      }

      header {
        padding: 12px;
        border-bottom: 1px solid $greyBorderModal;

        .btn {
          font-size: 12px;
          font-weight: 500;
          max-height: 24px;
          padding: 6px 10px !important;
        }

        .title {
          font-size: 14px;
          font-weight: 500;
        }
      }

      .group-title {
        padding: 18px 12px 8px;
        font-size: 12px;
        font-weight: 500;
        color: $greyPrimary;
      }

      ::v-deep .scroll-area {
        margin-top: 0;
        padding: 0;
        border-top: none;
      }
    }

    .member-select-view {
      position: relative;
      width: 100%;
    }

    .min-height {
      max-height: 1px;
      overflow: hidden;
    }

    .back-arrow {
      cursor: pointer;
      position: absolute;
      left: 16px;
      top: 16px;
      z-index: 999;
    }
  }
}

.number-invalid-popover {
  max-width: 305px;

  p.strong {
    margin-top: 16px;
  }
}

::v-deep input {
  border: none;
  height: 30px;
  font-size: 14px;
  color: $blackPrimary !important;
  box-shadow: none;
  padding-left: 8px !important;
  padding-right: 5px !important;
  background: unset !important;
  padding-top: unset;
  padding-bottom: unset;

  &:focus {
    background: unset !important;
    outline: none !important;
    border: none !important;
  }

  &::-webkit-search-cancel-button {
    display: none;
  }

  &::placeholder {
    color: $greyPrimary !important;
    opacity: 1;
  }
}

a, a * {
  text-decoration: none !important;
}
</style>
